import { ADMIN_URL, MANAGER_URL } from '../constants'

// Invited roles whose home is another app. Invites for the rest (consumer, guest,
// installer) are served here.
const INVITE_ROLE_APPS = {
    ADMIN: ADMIN_URL,
    PROPERTY_MANAGER: MANAGER_URL,
    PROPERTY_OWNER: MANAGER_URL,
}

// The roles claim is a JSON-encoded array, or "null" for a user who holds no persona yet
// (a pending utility applicant).
export const rolesFromUser = (user) => {
    const roles = JSON.parse(user?.signInUserSession?.idToken?.payload?.roles || '[]')
    return Array.isArray(roles) ? roles : []
}

// The app a sign-in that used an invite should land in, or null to stay here. Every invite
// link opens this app, so a consumer invited as an admin would otherwise stay on the
// consumer dashboard. Forwards only when the new token holds the invited role: the sign-in
// trigger ignores an expired invite or an admin invite to a non-staff address, and a stale
// invite cookie must not send anyone to an app that will refuse them.
export const inviteDestination = (invitedRole, tokenRoles, appUrls = INVITE_ROLE_APPS) => {
    const app = appUrls[invitedRole]
    return app && tokenRoles.includes(invitedRole) ? app : null
}
